export const pagesContractListEn = {
  pageTitle: "Contracts",
  addContract: "Add Contract",
  filterPlaceholder: "Filter contracts...",
  tabs: {
    employment: "Employment",
    contractorVendor: "Contractor & Vendor",
    leaseAsset: "Lease & Asset",
    software: "Software",
    all: "All",
  },
  columns: {
    contractNo: "Contract No.",
    contractTitle: "Contract Title",
    contractStatus: "Contract Status",
    contractStartDate: "Contract Start Date",
    contractEndDate: "Contract End Date",
    contractParty: "Contract Party (External)",
    responsiblePerson: "Responsible Person (Internal)",
  },
  headers: {
    contractNo: "Contract No.",
    contractTitle: "Contract Title",
    contractStatus: "Contract Status",
    contractStartDate: "Contract Start Date",
    contractEndDate: "Contract End Date",
  },
  status: {
    draft: "Draft",
    active: "Active",
    renewalPending: "Renewal Pending",
    terminated: "Terminated",
    cancelled: "Cancelled",
  },
  actions: {
    export: "Export",
    share: "Share",
  },
};
